import React from 'react';
import { useTheme } from "@emotion/react";
import { Box, Paper, useMediaQuery } from "@mui/material";

export default function HighlightZone(props) {

    const {data, odd} = props;
    
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    const handleRowOrder = odd ? "row" : "row-reverse";
    return (
        <Box
            id={data.id}
            key={data.id}
            sx={{mt: 1}}
        >
            <Box
                sx={{
                    p: {xs: 0, sm: 1, md: 2}
                }}
            >
                {data.info}
            </Box>
            <Paper
                key={data.buttonText}
                sx={{
                    marginBottom: 2,
                    mt: {xs: 2, sm: 1},
                    backgroundColor: "secondary.lightest",
                    paddingTop: 2,
                }}
            >
                <Box
                    sx={{
                        flexDirection: handleRowOrder,
                        flexWrap: {
                            xs: "wrap",
                            sm: "nowrap"
                        },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                    }}
                >
                    <Box
                        sx={{
                            flexBasis: "50%",
                            margin: 2,
                        }}
                    >
                        
                        <img src={data.image} alt="background" width={isXs  ? 240 : 290}
                            style={{
                                height:"80%"
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            flexGrow: 1,
                            margin: 2,
                            display: "flex",
                            justifyContent: "center",
                            width: "50%"
                            // display: "flex"
                        }}
                    >
                        {data.interaction}
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}